import { couponActions } from "../../actionTypes";

const initialState = {
	coupon: {},
	fetching: false,
	fetched: false,
	error: null,
};

const Reducer = (state = initialState, action) => {
	switch (action.type) {
		case couponActions.DELETE_COUPON: {
			return { ...state, ...initialState };
		}

		case couponActions.DELETE_COUPON_FULFILLED: {
			return {
				...state,
				fetching: false,
				fetched: true,
				coupon: action.payload,
			};
		}

		case couponActions.DELETE_COUPON_REJECTED: {
			return { ...state, fetching: false, error: action.payload };
		}

		default:
	}

	return state;
};

export default Reducer;
